<template>
  <div class="container">
    <h4 v-if="!(pagination.total === 0 && !keyword)">{{ $t('admin.system.type.title') }}</h4>
    <div class="selection" v-if="!(pagination.total === 0 && !keyword)">
      <a-input v-model="keyword" @change="search" :placeholder="$t('admin.system.type.searchPlaceholder')">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
      </a-input>
      <a-button type="primary" @click="create">{{ $t('admin.system.type.create') }}</a-button>
    </div>
    <div v-if="pagination.total === 0 && !keyword" class="noData">
      <img src="@/assets/img/no_data_lab_type.png" alt="">
      <span>{{ $t('admin.system.type.noData') }}</span>
      <a-button type="primary" @click="create">{{ $t('admin.system.type.create') }}</a-button>
    </div>
    <a-table
      v-else
      row-key="id"
      :columns="columns"
      :data-source="data">
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <span @click="edit(record)">{{ $t('admin.system.type.actions.edit') }}</span>
          <span v-if="!record.isAdmin" @click="delModal(record.id)">{{ $t('admin.system.type.actions.delete') }}</span>
        </div>
      </template>
    </a-table>
    <a-modal :title="$t('admin.system.type.form.title')" :visible="editShow" @ok="submitEdit" @cancel="editShow = false">
      <a-form :form="formEdit">
        <a-form-item :label="$t('admin.system.type.form.name.label')">
          <a-input
            allowClear
            :maxLength="15"
            v-decorator="['name', { rules: [{ required: true, message: $t('admin.system.type.form.name.required') }] }]"
            :placeholder="$t('admin.system.type.form.name.placeholder')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('admin.system.type.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('admin.system.type.deleteConfirm.content')}</p>`" />
  </div>
</template>

<script>
import {
  experimentTypeDel,
  experimentTypeList,
  experimentTypeSave
} from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      delId: undefined,
      delVisible: false,
      keyword: '',
      columns: [
        {
          title: this.$t('admin.system.type.columns.id'),
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: this.$t('admin.system.type.columns.name'),
          dataIndex: 'name'
        },
        {
          title: this.$t('admin.system.type.columns.createdAt'),
          dataIndex: 'createdAt'
        },
        {
          title: this.$t('admin.system.type.columns.operations'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      formEdit: this.$form.createForm(this),
      editShow: false
    }
  },
  methods: {
    handleTableChange() {
      this.getExperimentTypeList()
    },
    create() {
      this.editShow = true
      this.id = undefined
      this.formEdit.resetFields()
    },
    search() {
      this.pagination.page = 1
      this.getExperimentTypeList()
    },
    edit(record) {
      this.editShow = true
      this.id = record.id
      this.$nextTick(() => {
        this.formEdit.setFieldsValue({
          name: record.name
        })
      })
    },
    submitEdit() {
      this.formEdit.validateFields(async (err, values) => {
        if (!err) {
          const data = {
            id: this.id,
            name: this.formEdit.getFieldValue('name')
          }
          const res = await experimentTypeSave(data)
          if (res.code === 200) {
            this.editShow = false
            this.pagination.page = 1
            this.getExperimentTypeList()
            this.$message.success(this.$t('admin.system.type.messages.saveSuccess'))
          }
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      experimentTypeDel({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getExperimentTypeList()
          this.$message.success(this.$t('admin.system.type.messages.deleteSuccess'))
        }
      })
    },
    async getExperimentTypeList() {
      const data = {
        page: this.pagination.page,
        keyword: this.keyword,
        columnId: 3
      }
      const res = await experimentTypeList(data)
      if (res.code == 200) {
        this.data = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        nameMap(this.data)
        this.pagination.total = res.data.total
        const permissionList = localStorage.permissionList
        this.noPermissionModal = !permissionList || !permissionList.includes('admin_experimentType')
      }
    }
  },
  mounted() {
    this.getExperimentTypeList()
  }
}
</script>

<style lang="less" scoped>
.container{
  position: relative;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination{
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
.selection{
  display: flex;
  flex-wrap: wrap;
  margin-top: 22px;
  margin-bottom: 22px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix{
      >img{
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear{
      width: 14px;
      height: 14px;
    }
  }
}
.noData{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  flex-direction: column;
  justify-content: center;
  flex-direction: lab;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  > span{
    font-size: 14px;
    color: #0D2340;
    margin-top: -40px;
  }
  button{
    margin-top: 20px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
/deep/ .ant-btn.ant-btn-primary{
  width: auto;
}
.placeholder {
  font-size: 14px;
  font-weight: 400;
  color: #596777;
  line-height: 20px;
  margin-top: 12px;
}
</style>
